import useRecommenders from "@lululemon/ecom-story/src/components/recommenders-carousel/useRecommenders";
import { RecommendersCarousel } from "@lululemon/ecom-story/src/components/recommenders-carousel/recommenders-carousel";
export default RecommendersCarousel;
export { useRecommenders };
